<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="table"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    :height="330"
    size="mini"
    resizable
    border
    round
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:specInfo="{ row }">
      <span>{{ row.spec }} {{ row.specUnit }}</span>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openDetailDialog', {
                type: 'detail',
                form: row,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openDetailDialog', {
                type: 'edit',
                form: row,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i class="el-icon-delete tool-btn" @click="del(row)"></i>
        </el-tooltip>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
      table: {},
    }
  },
  watch: {
    tableData: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      this.table = this.tableData
    },

    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        let index = this.$refs.vxeGrid.getRowIndex(row)
        this.table.splice(index, 1)
      })
    },
  },
}
</script>
